import { Grid, ListItemIcon, MenuItem, Typography } from '@mui/material';
import { EbabAvatar } from '../../../Avatar';
import React from 'react';
import { useUserFields } from '../../../../hooks/user';

/** @component
 * Creates the header of the UserMenu.
 * Contains the users first and last name, email and avatar.
 * @returns {React.Element}
 * @constructor
 */
export const HeaderMenuItem = () => {
    const { getPrettyName, getEmail, getInitials } = useUserFields();
    return (
        <MenuItem
            key='HeaderMenuItem'
            data-analyticsid='account-handle'
            sx={{ pointerEvents: 'none' }}
        >
            <ListItemIcon
                style={{
                    verticalAlign: 'middle'
                }}
            >
                <EbabAvatar
                    alt={getInitials()}
                    style={{ width: '40px', height: '40px' }}
                />
            </ListItemIcon>
            <Grid container columns={1}>
                <Grid item xs={1}>
                    <Typography variant='body2'>{getPrettyName()}</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography variant='body2'>{getEmail()}</Typography>
                </Grid>
            </Grid>
        </MenuItem>
    );
};
